import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import type { LocationLaunchProps } from '@swf/casino';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import type { Dispatch } from '@swf/core/store';
import { ESGamingLimitForm } from '@swf/notification';

import { TXTWCL_Set_gaming_limits } from './SetGamingLimit.messages.json';
import styles from './SetGamingLimit.scss';

const SetGamingLimit: React.FC = () => {
  const {
    modal: { close },
    casino: { launch }
  } = useDispatch<Dispatch>();

  const { state } = useLocation<LocationLaunchProps>();

  const onSuccess = () => {
    close();
    launch(state);
  };

  return (
    <div>
      <Header>
        <Translation {...TXTWCL_Set_gaming_limits} />
        <CloseButton />
      </Header>
      <Body className={styles.body}>
        <ESGamingLimitForm onSuccess={onSuccess} />
      </Body>
    </div>
  );
};

export default SetGamingLimit;
